/*
  Shared scroll-snap carousel. Scrolling, snapping and touch swipe are native CSS
  (overflow-x + scroll-snap on the track); this only adds arrows, a counter,
  mouse drag and optional auto-rotate. Same behaviour as the reviews carousel.

  Markup:
    <div data-carousel data-rotate="5">          rotate = seconds per slide, 0/absent = off
      <button data-carousel-prev> <button data-carousel-next>
      <span data-carousel-count>1 / 6</span>      optional
      <div data-carousel-track> ...slides (direct children)... </div>
    </div>
  While dragging, the track gets the class "is-dragging" (turn scroll-snap off there).
*/
(function(){
  if(window.SGCarousel) return;

  function init(scope){
    var roots = scope.matches && scope.matches('[data-carousel]') ? [scope] : scope.querySelectorAll('[data-carousel]');
    Array.prototype.forEach.call(roots, function(root){
      if(root.dataset.carouselInit) return;
      var track = root.querySelector('[data-carousel-track]');
      var total = track ? track.children.length : 0;
      if(!total) return;
      root.dataset.carouselInit = '1';
      var counts = Array.prototype.filter.call(root.querySelectorAll('[data-carousel-count]'), function(c){ return c.closest('[data-carousel]') === root; });

      function step(){ return track.children[0].offsetWidth + (parseFloat(getComputedStyle(track).columnGap) || 0); }
      function maxScroll(){ return track.scrollWidth - track.clientWidth; }
      function atEnd(){ return track.scrollLeft >= maxScroll() - 2; }
      function index(){ return Math.max(0, Math.min(total - 1, Math.round(track.scrollLeft / step()))); }
      function goTo(i){ track.scrollTo({left: Math.max(0, Math.min(i * step(), maxScroll())), behavior: 'smooth'}); }
      /* arrows wrap around: next at the end returns to the start, prev at the start jumps to the end */
      function move(dir){
        if(dir > 0 && atEnd()) return goTo(0);
        if(dir < 0 && track.scrollLeft <= 2) return goTo(total - 1);
        goTo(index() + dir);
      }
      function updateCount(){
        var label = ((atEnd() ? total - 1 : index()) + 1) + ' / ' + total;
        Array.prototype.forEach.call(counts, function(c){ c.textContent = label; });
      }
      track.addEventListener('scroll', function(){ requestAnimationFrame(updateCount); }, {passive: true});
      updateCount();

      root.addEventListener('click', function(e){
        var btn = e.target.closest('[data-carousel-prev],[data-carousel-next]');
        if(!btn || btn.closest('[data-carousel]') !== root) return; /* nested carousel buttons belong to their own root */
        rest();
        move(btn.hasAttribute('data-carousel-next') ? 1 : -1);
      });

      /* drag-to-scroll with a mouse; touch uses native swipe + snap */
      var dragging = false, moved = false, startX = 0, startLeft = 0;
      track.addEventListener('pointerdown', function(e){
        if(e.pointerType !== 'mouse') return;
        dragging = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
      });
      track.addEventListener('pointermove', function(e){
        if(!dragging) return;
        var dx = e.clientX - startX;
        if(!moved && Math.abs(dx) > 4){
          /* capture only once it's a real drag, so plain clicks stay intact */
          moved = true;
          track.classList.add('is-dragging');
          track.setPointerCapture(e.pointerId);
        }
        if(moved) track.scrollLeft = startLeft - dx;
      });
      function endDrag(){
        if(!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
        if(moved){ rest(); goTo(index()); } /* settle on nearest slide */
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('click', function(e){ if(moved){ e.preventDefault(); moved = false; } }, true);
      track.addEventListener('dragstart', function(e){ e.preventDefault(); }); /* no ghost image when dragging a photo */

      /* optional auto-rotate; pauses on hover, focus, touch and for a while after any interaction */
      var rotate = parseInt(root.dataset.rotate, 10) || 0;
      var restUntil = 0;
      function rest(){ restUntil = Date.now() + rotate * 2000; }
      if(rotate > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches){
        track.addEventListener('touchstart', rest, {passive: true});
        var timer = setInterval(function(){
          if(!root.isConnected) return clearInterval(timer); /* section re-rendered in the theme editor */
          if(document.hidden || Date.now() < restUntil || root.matches(':hover') || root.querySelector(':focus-visible')) return;
          if(maxScroll() > 2) move(1);
        }, rotate * 1000);
      }
    });
  }

  window.SGCarousel = {init: init};
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
